import { request } from '@umijs/max'
import { BPIAM_API, BRAIN_API, MARKETING_API } from '@/constants/API';

// 获取用户菜单信息
export async function userinfoMenu() {
  return request(`${BPIAM_API}/userinfo/system/${process.env.menuId}`);
}

// AI生成用户头像
export async function workflowLogo(params: any) {
  let appKey = ''
  let version = '';
  switch (process.env.UMI_ENV) {
    case 'uat':
      appKey = '40fd55770e'
      version = 'dev'
      break;
    case 'test':
      appKey = 'a51f823d78'
      version = 'prod'
      break;
    case 'af':
      appKey = 'a51f823d78'
      version = 'prod'
      break;
    default:
      appKey = 'a51f823d78'
      version = 'prod'
      break;
  }
  if (typeof process.env.UMI_ENV === 'undefined') {
    version = 'dev'
  }
  let data = {}
  if (version === 'dev') {
    data = {
      ...params,
      appKey,
      version,
    }
  } else {
    data = {
      ...params,
      appKey,
      version
    }
  }
  return request(`${BRAIN_API}/workflow/chatFlow`, {
    method: 'POST',
    data,
  });
}

// 新增/编辑助手信息
export async function assistantUpdate(params: any) {
  return request(`${MARKETING_API}/product/assistant/saveOrUpdate`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  });
}

// 删除助手
export async function deleteAssistantState(id: string | number) {
  return request(`${MARKETING_API}/product/assistant/deleteAssistantState/${id}`);
}

// 禁用助手
export async function updateAssistantState(id: string | number) {
  return request(`${MARKETING_API}/product/assistant/updateAssistantState/${id}`);
}

// 替换知识库
export async function replaceFolder(params: any) {
  return request(`${MARKETING_API}/folder/replace_folder`, {
    method: 'PUT',
    data: {
      ...params,
    }
  });
}

// 热点的/日历详情
export async function getSmartPushSchemeDetails(id: any) {
  return request(`${MARKETING_API}/scheme/parameter/getHotspotDataSchemeDetails/${id}`, {
    method: 'get',
  });
}